import React from 'react';

import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { HiOutlineBackspace } from 'react-icons/hi';

import { Button } from 'modules/common/input';

function Card({ parentMatch }) {
  const history = useHistory();

  const [refNo, setRef] = React.useState([]);

  const handleOnClick = (v) => () => {
    setRef((prevState) => {
      if (v === 'clear') {
        return [];
      }

      if (v === 'backspace') {
        return prevState?.slice(0, -1);
      }

      return `${prevState}${v}`;
    });
  };
  const handleOnComplete = () => {
    history.push(`${parentMatch?.url}/receipt`);
  };

  const format = (arr) => {
    const $arr = arr?.join('');
    return `${$arr?.slice(0, 4)} ${$arr?.slice(4, 9)} ${$arr?.slice(9, 13)}`;
  };

  const zeros = [...new Array(13 - (refNo?.length || 0))]?.map(() => 0);
  const referenceNumber = [...refNo, ...zeros];

  return (
    <div className="flex flex-col flex-1 items-center md:mt-7 p-3 md:p-5 overflow-y-auto overflow-x-hidden">
      <div className="w-full max-w-[500px] space-y-3">
        <div className="space-y-2">
          <div className="font-semibold text-base md:text-xl">
            Enter payment reference number
          </div>

          <div className="card rounded">
            <div className="text-xs text-gray-500">
              REFERENCE NUMBER (OPTIONAL)
            </div>
            <div className="text-2xl font-semibold">
              {refNo?.length <= 0 ? format(zeros) : format(referenceNumber)}
            </div>
          </div>
        </div>

        <div className="p-5 bg-gray-50">
          <div className="grid grid-cols-3 gap-3">
            {[...new Array(9)]?.map((item, key) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={key}
                className="card p-3 text-center h-16 flex text-lg font-medium text-gray-600 cursor-pointer"
                onClick={handleOnClick(key + 1)}
                role="presentation"
              >
                <div className="m-auto">{key + 1}</div>
              </div>
            ))}

            {refNo?.length > 0 ? (
              <div
                className="card p-3 text-center h-16 flex font-medium text-gray-600 cursor-pointer"
                onClick={handleOnClick('clear')}
                role="presentation"
              >
                <div className="m-auto">Clear</div>
              </div>
            ) : (
              <div />
            )}

            <div
              className="card p-3 text-center h-16 flex text-lg font-medium text-gray-600 cursor-pointer"
              onClick={handleOnClick(0)}
              role="presentation"
            >
              <div className="m-auto">0</div>
            </div>

            {refNo?.length > 0 ? (
              <div
                className="card p-3 text-center h-16 flex text-lg font-medium text-gray-600 cursor-pointer"
                onClick={handleOnClick('backspace')}
                role="presentation"
              >
                <div className="m-auto">
                  <HiOutlineBackspace className="h-6 w-6" />
                </div>
              </div>
            ) : (
              <div />
            )}
          </div>
        </div>

        <div>
          <Button
            className="btn outline-primary md:primary font-semibold w-full"
            label="Complete Transaction"
            onClick={handleOnComplete}
          />
        </div>
      </div>
    </div>
  );
}

Card.defaultProps = {
  parentMatch: {},
};

Card.propTypes = {
  parentMatch: PropTypes.instanceOf(Object),
};

export default Card;
